import { Table, PageHeader } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useStoreState, createComponentStore } from "easy-peasy";

import {
  UserEventStoreModel,
  ACTION_TYPES,
} from "store/models/reports/user-events";
import { formatDate } from "Utils";

const useUserEventsStore = createComponentStore(UserEventStoreModel);

export default function UserProfileEventsPage() {
  const { user } = useStoreState((store) => store.auth);
  const [store, actions] = useUserEventsStore();
  const { searchHelp } = actions;
  const { process, data } = store;
  const [filteredValue, setFilteredValue] = useState({
    userId: user.id,
  });

  useEffect(() => {
    searchHelp({ sort: "createdAt,DESC", ...filteredValue });
  }, []);

  const columns = [
    {
      title: "Kullanıcı",
      dataIndex: "user",
      key: "user",
      render: (text, record) => record.user.name + " " + record.user.surname,
    },
    {
      title: "Olay ",
      dataIndex: "eventText",
      sorter: (a, b) => a.eventText.localeCompare(b.eventText),
      key: "eventText",
    },

    {
      title: "Oluşma Tarihi",
      dataIndex: "createdAt",
      key: "createdAt",
      sorter: (a, b) => moment(a.createdAt).unix() - moment(b.createdAt).unix(),
      defaultSortOrder: "descend",
      render: (text, record) => formatDate(record.createdAt),
    },
  ];

  return (
    <>
      <PageHeader title="Son Aktivitelerim" />
      <Table
        style={{ margin: "0 24px" }}
        rowKey={(row) => row.id}
        loading={process === ACTION_TYPES.FETCHING_DATA}
        dataSource={data}
        columns={columns}
        size="small"
        bordered
        showSorterTooltip={false}
        scroll={{ x: 1000, scrollToFirstRowOnChange: true }}
      />
    </>
  );
}
